/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './validation-message.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/login/validation-message/validation-message.component';
const styles_ValidationMessageComponent:any[] = [i0.styles];
export const RenderType_ValidationMessageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ValidationMessageComponent,data:{}});
function View_ValidationMessageComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(1,(null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.errorMessage;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ValidationMessageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ValidationMessageComponent_1)),i1.ɵdid(1,16384,(null as any),0,i2.NgIf,
      [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
      i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.ValidationMessageComponent = _v.component;
    const currVal_0:any = (_co.errorMessage !== (null as any));
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_ValidationMessageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-validation-message',
      ([] as any[]),(null as any),(null as any),(null as any),View_ValidationMessageComponent_0,
      RenderType_ValidationMessageComponent)),i1.ɵdid(1,114688,(null as any),0,i3.ValidationMessageComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ValidationMessageComponentNgFactory:i1.ComponentFactory<i3.ValidationMessageComponent> = i1.ɵccf('app-validation-message',
    i3.ValidationMessageComponent,View_ValidationMessageComponent_Host_0,{control:'control',
        field:'field'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL2xvZ2luL3ZhbGlkYXRpb24tbWVzc2FnZS92YWxpZGF0aW9uLW1lc3NhZ2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL2hhbWFkYS9Eb2N1bWVudHMvZ2l0X3ZlcmlmeS9rdXJ1bWFqaXRlbl9hb3Qva3VydW1haml0ZW4vc3JjL2FwcC9sb2dpbi92YWxpZGF0aW9uLW1lc3NhZ2UvdmFsaWRhdGlvbi1tZXNzYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL0M6L1VzZXJzL2hhbWFkYS9Eb2N1bWVudHMvZ2l0X3ZlcmlmeS9rdXJ1bWFqaXRlbl9hb3Qva3VydW1haml0ZW4vc3JjL2FwcC9sb2dpbi92YWxpZGF0aW9uLW1lc3NhZ2UvdmFsaWRhdGlvbi1tZXNzYWdlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvaGFtYWRhL0RvY3VtZW50cy9naXRfdmVyaWZ5L2t1cnVtYWppdGVuX2FvdC9rdXJ1bWFqaXRlbi9zcmMvYXBwL2xvZ2luL3ZhbGlkYXRpb24tbWVzc2FnZS92YWxpZGF0aW9uLW1lc3NhZ2UuY29tcG9uZW50LnRzLlZhbGlkYXRpb25NZXNzYWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiAqbmdJZj1cImVycm9yTWVzc2FnZSAhPT0gbnVsbFwiPnt7ZXJyb3JNZXNzYWdlfX08L2Rpdj5cclxuIiwiPGFwcC12YWxpZGF0aW9uLW1lc3NhZ2U+PC9hcHAtdmFsaWRhdGlvbi1tZXNzYWdlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSx3RUFBbUM7YUFBQTs7SUFBQTtJQUFBOzs7O29CQUFuQztNQUFBLDJDQUFBO01BQUEsc0VBQXlEO2FBQUE7O0lBQXBEO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0FBO01BQUE7MkNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/login/validation-message/validation-message.component.ngfactory.ts